import { Info } from '../icons/Info'
import { Rank } from '../icons/Rank'
import { Cog } from '../icons/Cog'
import logo from '../../logo.svg'
import { FullScreen } from '../icons/FullScreen'
import { useEffect, useState } from 'react'

type Props = {
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
}

export const Navbar = ({
  setIsInfoModalOpen,
  setIsStatsModalOpen,
  setIsSettingsModalOpen,
}: Props) => {

  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const checkIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    setIsIOS(checkIOS);
  }, []);

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }
  return (
    <div className="navbar">
      <div className="navbar-content px-5">
        <div className="site-info flex gap-2 items-center">
          <div
            className="h-8 w-8 cursor-pointer flex items-center justify-center"
            onClick={() => setIsInfoModalOpen(true)}
          >
            <Info />
          </div>
          <div className="navbar-brand">
            <a href="/"><img src={logo} className='h-8 w-auto' alt='OzWord' /></a>
          </div>
        </div>
        <div className="right-icons flex items-center">
          {!isIOS && (
            <div className="w-8 h-8 rounded-full mr-3 cursor-pointer bg-white flex justify-center items-center" onClick={() => toggleFullScreen()}>
              <FullScreen className="h-5 w-5 fill-secondary-sdc" />
            </div>
          )}
          <div className="w-8 h-8 rounded-full mr-3 cursor-pointer bg-white flex justify-center items-center" onClick={() => setIsStatsModalOpen(true)}>
            <Rank className="h-5 w-5 fill-secondary-sdc" />
          </div>
          <div className="w-8 h-8 rounded-full cursor-pointer bg-white flex justify-center items-center" onClick={() => setIsSettingsModalOpen(true)}>
            <Cog className="h-5 w-5 fill-secondary-sdc" />
          </div>
        </div>
      </div>
    </div >
  )
}
